



import React, { useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";
import { connectSocket } from "../../socket/socket";
import { Eye, EyeOff } from "lucide-react";
import { saveLoginLocationApi } from "../../app/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("--- Login Started ---");
    setLoading(true);

    try {
      const res = await fetch("https://demouptask.visiontrek.io/api/users/login", {
        // const res = await fetch("http://192.168.1.16:6655/api/users/login", {

        // const res = await fetch("/api/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log("Response data received:", data);

      if (res.ok && data.success) {
        console.log("Login successful, processing cookies and storage...");
        Cookies.set("token", data.data.token, {
          expires: 7,
          sameSite: "lax",
        });

        localStorage.setItem("user", JSON.stringify(data.data.user));
        toast.success("Login successful");
        console.log("Login successful, token set, user saved.");






        // ✅ ADD THIS LINE
        connectSocket();



        // Save Login Location
        console.log("Checking for geolocation support...");
        if (window.location.protocol === "http:" && window.location.hostname !== "localhost") {
          console.error("CRITICAL: Geolocation API only works on HTTPS or localhost. Current origin is insecure.");
          toast.error("Location tracking requires HTTPS");
        }

        if ("geolocation" in navigator) {
          console.log("Geolocation is supported. Requesting position...");
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              console.log("Position obtained:", latitude, longitude);
              try {
                console.log("Fetching area from Nominatim...");
                const geoRes = await fetch(
                  `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
                );
                const geoData = await geoRes.json();
                console.log("GeoData received:", geoData);

                const area =
                  geoData.address.suburb ||
                  geoData.address.city ||
                  geoData.address.state ||
                  "Unknown";
                console.log("Determined Area:", area);

                console.log("Sending location to backend API...");
                const result = await saveLoginLocationApi({
                  latitude: latitude.toString(),
                  longitude: longitude.toString(),
                  area: area,
                });
                console.log("Backend API response:", result);
              } catch (err) {
                console.error("Error in location save process:", err);
              }
            },
            (error) => {
              console.error("Geolocation error callback:", error.message);
              toast.error("Location access denied or failed.");
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0,
            }
          );
        } else {
          console.warn("Geolocation is not supported by this browser.");
        }

        setTimeout(() => {
          console.log("Redirecting to dashboard...");
          window.location.href = "/";
        }, 3000);
      } else {
        toast.error(data.message || "Login failed");
      }
    } catch (err) {
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="
      min-h-screen flex items-center justify-center
      bg-gradient-to-br from-[#1b0f3a] via-[#291857] to-[#12092b]
      px-4
    ">

      {/* Glass Card */}
      <div className="
        w-full max-w-sm
        bg-white/10 backdrop-blur-xl
        border border-white/20
        rounded-2xl
        shadow-[0_30px_100px_rgba(0,0,0,0.6)]
        p-8 text-white
      ">

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center shadow">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5s-3 1.343-3 3 1.343 3 3 3z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21H5a2 2 0 01-2-2v-1c0-2.761 4.477-5 9-5s9 2.239 9 5v1a2 2 0 01-2 2z" />
            </svg>
          </div>
        </div>

        <h2 className="text-center text-xl font-semibold">
          SIGN IN TO UPTASK
        </h2>
        <p className="text-center text-sm text-white/70 mt-1 mb-6">
          Enter your credentials to continue
        </p>

        <form onSubmit={handleLogin} className="space-y-4">

          {/* Email */}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="
              w-full px-4 py-3 rounded-md
              bg-white/10 border border-white/20
              text-white placeholder-white/50
              focus:outline-none focus:ring-2 focus:ring-purple-400
            "
            required
          />

          {/* Password */}
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="
                w-full px-4 py-3 pr-12 rounded-md
                bg-white/10 border border-white/20
                text-white placeholder-white/50
                focus:outline-none focus:ring-2 focus:ring-purple-400
              "
              required
            />

            {/* <button
              type="button"
              onClick={() => setShowPassword((p) => !p)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white"
            >
              {showPassword ? "🙈" : "👁️"}
            </button> */}

            <button
              type="button"
              onClick={() => {
                if (!password) return; // ❌ prevent toggle if empty
                setShowPassword((p) => !p);
              }}
              disabled={!password}
              className={`
    absolute right-4 top-1/2 -translate-y-1/2 transition
    ${password ? "text-black hover:text-black" : "text-black/30 cursor-not-allowed"}
  `}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {/* Forgot */}
          {/* <div className="text-right text-sm text-white/70">
            <span className="hover:underline cursor-pointer">
              Forgot password?
            </span>
          </div> */}

          {/* Button */}
          <button
            type="submit"
            disabled={loading}
            className="
              w-full py-3 mt-2 rounded-md
              bg-gradient-to-r from-purple-600 to-indigo-600
              text-white font-medium
              hover:opacity-90 transition
              shadow-xl disabled:opacity-60
            "
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
